export default __webpack_public_path__ + "static/media/in.0b11b65e.svg";